import { SectionSpacer } from '~/ui-rocco/pages/home-page/components/SectionSpacer';
import { ProfessionalAboutIntroSection } from './sections/ProfessionalAboutIntroSection';
import { ProfessionalAboutTabSection } from './sections/ProfessionalAboutTabSection';
import { ProfessionalAboutAwardsSection } from './sections/ProfessionalAboutAwardsSection';
import { ProfessionalAboutContentSection } from './sections/ProfessionalAboutContentSection';
import { ProfessionalAboutTeamSection } from './sections/ProfessionalAboutTeamSection';
import { ProfessionalContactSection } from './sections/ProfessionalContactSection';

/**
 * BC-4572 — revamped professional About tab (/info).
 *
 * Light editorial shell: hero + sub-nav, the "About us" intro (project value +
 * CTAs), About the practice as the project lays it out — picture left, copy
 * right — then Awards and Meet the Team as sections, a numbered accordion of
 * testimonials,
 * and the shared "Talk to us" + closing.
 * Rendered behind the revamp flag; the index route serves overview data so the
 * reused sections resolve.
 */
export const ProfessionalAboutPageRevamp = () => {
    return (
        <main
            id="main-content"
            data-testid="professional-about-page-revamp"
            className="bg-ground ground-grey max-md:pb-16 md:pb-[6.25rem]"
        >
            <ProfessionalAboutIntroSection />
            {/* Desktop 0: the intro block above already carries the shared
                tab-to-content gap, and this spacer was sized for the display
                heading and standfirst it used to sit under. Mobile still needs
                it — the intro is desktop-only there. */}
            <SectionSpacer
                height={0}
                mobileHeight={12}
                className="bg-ground"
                unit="rem"
            />
            <ProfessionalAboutTabSection />
            <ProfessionalAboutAwardsSection />
            <ProfessionalAboutTeamSection />
            <ProfessionalAboutContentSection />
            <ProfessionalContactSection />
        </main>
    );
};
